import React, { useCallback } from 'react'

const ClickLink = ({
  className,
  onClick,
  children,
}) => {

  const onOpen = useCallback((e) => {
    e.preventDefault()
    e.stopPropagation()
    onClick()
    return false
  }, [
    onClick,
  ])

  return (
    <a href="#" onClick={ onOpen } className={ className }>
      { children }
    </a>
  )
}

export default ClickLink